export class PaperSpecification {
  paperType: string | undefined;
  paperBleeds: string | undefined;
  bookPaperColor: string | undefined;
  endSheetOptionId: string | undefined;

  constructor() {
    this.paperType = undefined;
    this.paperBleeds = undefined;
    this.bookPaperColor = undefined;
    this.endSheetOptionId = undefined;
  }
}
